// extracted by mini-css-extract-plugin
export default {"tableRow":"challanList_tableRow__ShnAP","tableCell":"challanList_tableCell__E2I8r"};